var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.values),function(id,index){return _c('Field',{key:index,attrs:{"model":id.label,"type":"text","label":id.name,"disabled":true,"border":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }